import { render, staticRenderFns } from "./AnimeItem.vue?vue&type=template&id=6e128c45&scoped=true&"
import script from "./AnimeItem.vue?vue&type=script&lang=js&"
export * from "./AnimeItem.vue?vue&type=script&lang=js&"
import style0 from "./AnimeItem.vue?vue&type=style&index=0&id=6e128c45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e128c45",
  null
  
)

export default component.exports